const CollectionsData = [
  {
    collection_id: "148",
    collection_name: "Residential Liner",
  },
  {
    collection_id: "2",
    collection_name: "Commercial Membrane",
  },
];

export default CollectionsData;
